import React, { useEffect, useRef } from "react";

const MessageDialog = ({ message, type, setMessage, setMsgType, duration = 10000, onClose }) => {
    const timerRef = useRef(null);

    useEffect(() => {
        if (!message) return;

        timerRef.current = setTimeout(() => {
            setMessage("");
            setMsgType("");
            if (onClose) {
                onClose();
            }
        }, duration || 10000);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [message, setMessage, setMsgType, duration, onClose]);

    const handleClose = () => {
        setMessage("");
        setMsgType("");
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (onClose) {
            onClose();
        }
    };

    if (!message) return null;

    const dialogClass =
        type === "success"
            ? "alert-success"
            : type === "warning"
                ? "alert-warning"
                : "alert-danger";

    return (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className={`modal-content ${dialogClass}`}>
                    <div
                        className={`modal-header ${type === "success"
                            ? "bg-success text-white"
                            : type === "warning"
                                ? "bg-warning text-dark"
                                : "bg-danger text-white"
                            }`}
                    >
                        <h5 className="modal-title">
                            {type === "success"
                                ? "Success"
                                : type === "warning"
                                    ? "Warning"
                                    : "Error"}
                        </h5>
                        <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body" style={{ whiteSpace: "pre-line" }}>
                        <p className="mb-0">{message}</p>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className={`btn ${type === "success"
                                ? "btn-success"
                                : type === "warning"
                                    ? "btn-warning"
                                    : "btn-danger"
                                }`}
                            onClick={handleClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MessageDialog;